export const CATEGORY_TYPE = `
    value: id
    label: name
`;
